import { render, staticRenderFns } from "./ResetPasswordStep4.vue?vue&type=template&id=23ae26b2&scoped=true"
import script from "./ResetPasswordStep4.vue?vue&type=script&lang=js"
export * from "./ResetPasswordStep4.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordStep4.vue?vue&type=style&index=0&id=23ae26b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ae26b2",
  null
  
)

export default component.exports